// extracted by mini-css-extract-plugin
export const passwordIconButton = "checkout-module--password-icon-button--3druB";
export const checkoutPageWrapper = "checkout-module--checkout-page-wrapper--1UAiD";
export const email = "checkout-module--email--26ZIb";
export const passwordCopy = "checkout-module--passwordCopy--rarlL";
export const divider = "checkout-module--divider--1VUgq";
export const socialButtons = "checkout-module--social-buttons--1QC9t";
export const previewWrapper = "checkout-module--preview-wrapper--1nGJT";
export const previewContent = "checkout-module--preview-content--26uXU";
export const itemImageWrapper = "checkout-module--item-image-wrapper--laJ44";
export const quantityCircle = "checkout-module--quantity-circle--3xlnO";
export const strikethrough = "checkout-module--strikethrough--1_T3c";
export const tableLabel = "checkout-module--table-label--1mNlj";
export const tableValue = "checkout-module--table-value--3LktF";
export const tableValueShipping = "checkout-module--table-value-shipping--xmYn5";
export const tableTotal = "checkout-module--table-total--aMBX0";
export const promoCodeContainer = "checkout-module--promo-code-container--zu6ZA";
export const shippingFormWrapper = "checkout-module--shipping-form-wrapper--1FKeO";
export const shippingMethodForm = "checkout-module--shipping-method-form--1re1q";
export const shippingMethod = "checkout-module--shipping-method--1DpCw";
export const shippingPlaceholder = "checkout-module--shipping-placeholder--2jxtk";
export const hidden = "checkout-module--hidden--2_x13";
export const shippingMethodCta = "checkout-module--shipping-method-cta--S8_cK";
export const countryFieldWrapper = "checkout-module--country-field-wrapper--2x722";
export const popup = "checkout-module--popup--3KAxz";
export const popupWrapper = "checkout-module--popup-wrapper--1gf95";
export const popupContent = "checkout-module--popup-content--1-ukG";
export const savedCard = "checkout-module--saved-card--3JSR3";
export const accountForm = "checkout-module--account-form--1Uc3G";
export const addressForm = "checkout-module--address-form--1lc5U";
export const stripeCardElement = "checkout-module--stripe-card-element--3LqtQ";
export const formActionsWrapper = "checkout-module--form-actions-wrapper--3wJVe";
export const footer = "checkout-module--footer--3WS1x";
export const list = "checkout-module--list--3o6Ag";
export const copyright = "checkout-module--copyright--1v8os";
export const loaderWrapper = "checkout-module--loader-wrapper--1Oj-W";
export const rotate = "checkout-module--rotate--1suib";